<template>
  <BillingComponent />
</template>

<script>
// @ is an alias to /src
import BillingComponent from "@/sections/voiceplus/components/BillingComponent.vue";
import config from "@/config";

export default {
  name: "Modules",
  components: {
    BillingComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
